import { createSlice } from "@reduxjs/toolkit";
import { GrupoPlanoContaFinanceiroModel } from "../../../models/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroModel";
import { buscarGrupoPlanoContaFinanceiro } from "../../../services/grupoPlanoContaFinanceiroService";
import { resetAll } from "../../actions/actions";

export interface GrupoPlanoContaFinanceiroState {
  //buscar grupo plano conta financeiro
  loading: boolean;
  busca: string | null;
  list: GrupoPlanoContaFinanceiroModel[];
  entity: GrupoPlanoContaFinanceiroModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: GrupoPlanoContaFinanceiroState = {
  //buscar grupo plano conta financeiro
  loading: false,
  busca: null,
  list: [],
  entity: {} as GrupoPlanoContaFinanceiroModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const grupoPlanoContaFinanceiroSlice = createSlice({
  name: "grupoPlanoContaFinanceiro",
  initialState,
  reducers: {
    //buscar grupo plano conta financeiro
    setBuscaGrupoPlanoContaFinanceiro: (state, action) => {
      state.busca = action.payload;
    },
    setEntityGrupoPlanoContaFinanceiro: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarGrupoPlanoContaFinanceiro: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarGrupoPlanoContaFinanceiro: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar grupo plano conta financeiro
    builder.addCase(buscarGrupoPlanoContaFinanceiro.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarGrupoPlanoContaFinanceiro.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarGrupoPlanoContaFinanceiro.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar grupo plano conta financeiro
  setBuscaGrupoPlanoContaFinanceiro,
  setEntityGrupoPlanoContaFinanceiro,
  //internal
  setModalCadastrarGrupoPlanoContaFinanceiro,
  setModalDeletarGrupoPlanoContaFinanceiro,
} = grupoPlanoContaFinanceiroSlice.actions;

export default grupoPlanoContaFinanceiroSlice.reducer;
